/** 
 * Hook para requisições HTTP
 * 
 * import useFetch from 'hooks/useFetch';
 * const { get, post, put, del } = useFetch();
 * 
 * @returns {Response} { get, post, put, del }
 *      Response {
 *          result: {…}, // resultado da requisição se houver
 *          error: undefined, // erro da requisição se houver
 *          type: "cors",
 *          url: "API_URL/route",
 *          redirected: false,
 *          status: 200, ok: true,
 *          statusText: "OK",
 *          headers: Headers(2),
 *          body: ReadableStream,
 *          bodyUsed: true
 *      }
 * 
 * @example
 * 
 * /// GET ou DELETE
 * let response = await get(`/exemplo${query}`);
 * if (response.ok) {
 *     let dados = response.result; // pega o retorno da requisição
 *     let exemplos = dados.data; // pega os dados da requisição
 *     let mensagem = dados.message; // pega a mensagem da requisição
 *     return exemplos;
 * } else if (response.error) {
 *     console.log(response);
 *     console.error('Erro no buscarExemplos()', response.error);
 * }
 * 
 * /// POST ou PUT
 * let response = await post(`/exemplo`, { nome: "Exemplo", descricao: "Descrição do exemplo" });
 * if (response.ok) {
 *    let dados = response.result; // pega o retorno da requisição
 *    return dados.data;
 * } else if (response.error) {
 *    console.log(response);
 *    console.error('Erro no buscarExemplos()', response.error);
 * }
 */


/* eslint import/no-anonymous-default-export: [2, {"allowArrowFunction": true}] */
export default () => {
    console.log("API_URL CARREGADA:", process.env.REACT_APP_API_URL);
    const token = localStorage.getItem('authToken');
    const API_URL = process.env.REACT_APP_API_URL;
    const API_OPTIONS = {
        headers: {
            Accept: "application/json",
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
        },
    };

    const defaultFetch = async (route, method, accept = null, body = null, content_type = null) => {
        let customOptions = { ...API_OPTIONS };
        if (accept) {
            customOptions.headers["Accept"] = accept;
        } if (body) {
            if (content_type === "multipart/form-data") {
                customOptions.body = body;
            } else {
                customOptions.body = JSON.stringify(body);
            }
        } if (content_type) {
            if (content_type === "multipart/form-data") {
                // remove o header Content-Type para o fetch não dar erro
                delete customOptions.headers["Content-Type"];
            } else {
                customOptions.headers["Content-Type"] = content_type;
            }
        }
        let response;
        try {
            response = await fetch(`${API_URL}${route}`, {
                ...customOptions,
                method: method,
            });
            response.result = await response.json();
            return response;
        } catch (error) {
            console.error(`Erro no fetch para URL ${route}: ${error}`);
            // Se o fetch() em si falhou (rede fora do ar, CORS bloqueado, etc.),
            // 'response' ainda é undefined aqui — sem este fallback, o código
            // quebrava tentando gravar em undefined e o erro real nunca chegava
            // até a tela (falha silenciosa, sem aviso pro usuário).
            if (!response) {
                response = { ok: false, status: 0 };
            }
            response.error = error;
            return response;
        }
    }

    const get = async (route) => {
        return await defaultFetch(route, "GET");
    }

    const post = async (route, body, accept = null, content_type = null) => {
        return await defaultFetch(route, "POST", accept, body, content_type);
    }

    const put = async (route, body, accept = null, content_type = null) => {
        return await defaultFetch(route, "PUT", accept, body, content_type);
    }

    const del = async (route) => {
        return await defaultFetch(route, "DELETE");
    }

    return { get, post, put, del };
}